import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'canvas-two-column-layout',
    templateUrl: './two-column-layout.component.html',
    styleUrl: './two-column-layout.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TwoColumnLayoutComponent {}
